import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faUnlink } from "@fortawesome/free-solid-svg-icons";

const funcBtnStyle = {
  background: "#2196f3",
  color: "#fff",
  border: "none",
  borderRadius: 4,
  padding: "10px 24px",
  fontWeight: "bold",
  margin: "6px 6px",
  cursor: "pointer",
  minWidth: 120,
  minHeight: 38,
};

const DoorlockTileDetail = ({
  roomDetail,
  roomItem,
  frameNumber,
  connected,
  handleLogsModalOpen,
  handleCheckOutChangeModalOpen,
  handleFrameCount,
  handleForcedOpening,
  handleSetDoorLockTime,
  handleChangeDoorLockSequenceNumber,
  handleMoveRoomCardKeyModalOpen,
  handleChangeRoomStatusModalOpen,
  handleMoveRoomPinCodeModalOpen,
  handleChangeLockOutPinCode,
  handleMqttModalOpen,
  handleMqttReconnect,
}) => {
  const { t } = useTranslation(); //i18N 다국어 부분 (locales 폴더 참조)

  return (
    <div
      style={{
        padding: 20,
        background: "#23262d",
        color: "#fff",
        borderRadius: 8,
      }}
    >
      {/* 상태 정보 */}
      <div style={{ marginBottom: 16 }}>
        <div>
          {t("doorlock_detail_modal.room")} : {roomDetail?.name}
        </div>
        <div>
          {t("doorlock_detail_modal.room_condition")} : {roomItem?.room_status}
        </div>
        <div>
          {t("doorlock_detail_modal.check_in_out")} :{" "}
          {roomItem?.checkin_at
            ? moment(roomItem.checkin_at).format("YYYY/MM/DD HH:mm:ss")
            : "-"}
          {" ~ "}
          {roomItem?.checkout_at
            ? moment(roomItem.checkout_at).format("YYYY/MM/DD HH:mm:ss")
            : "-"}
        </div>
        <div>
          {t("doorlock_detail_modal.card_key_issuance_information")} :{" "}
          {roomItem?.issued_card_key_count}
        </div>
        <div>
          {t("doorlock_detail_modal.pin_code_issuance_information")} :{" "}
          {roomItem?.issued_pincode_key_count}
        </div>
        <div>
          {t("doorlock_detail_modal.mobile_key_issuance_information")} :{" "}
          {roomItem?.issued_mobile_key_count}
        </div>
        <div>
          {t("doorlock_detail_modal.last_update_time")} :
          {roomItem?.last_status_updated_at
            ? moment(roomItem.last_status_updated_at).format(
                "YYYY/MM/DD HH:mm:ss"
              )
            : "-"}
        </div>
        <div>
          {t("data_column.battery_status")} :
          {roomItem?.fw_battery > -1 ? roomItem?.fw_battery + "%" : "-"}
        </div>
      </div>
      {/* 로라 네트웍 정보 + 상태 */}
      <div style={{ marginBottom: 8, fontWeight: "bold" }}>
        {t("doorlock_detail_modal.lora_network_information")}
      </div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        <button
          style={{
            background: "#2196f3",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            padding: "6px 16px",
            marginRight: 10,
            fontWeight: "bold",
            cursor: "pointer",
          }}
          onClick={handleMqttReconnect}
        >
          {t("doorlock_detail_modal.lora_network_information")}
        </button>
        {connected ? (
          <div
            style={{
              color: "#4caf50",
            }}
          >
            <FontAwesomeIcon icon={faLink} style={{ paddingRight: "2px" }} />{" "}
            MQTT 연결됨
          </div>
        ) : (
          <div
            style={{
              color: "#f44336",
            }}
          >
            <FontAwesomeIcon icon={faUnlink} style={{ paddingRight: "2px" }} />{" "}
            MQTT 연결 끊김
          </div>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
        <p
          style={{
            color:
              frameNumber?.dc_frame_number === frameNumber?.ds_frame_number
                ? "green"
                : "red",
            fontWeight: "bold",
          }}
        >
          Control Frame Number : {frameNumber?.dc_frame_number}
        </p>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
        <p
          style={{
            color:
              frameNumber?.dc_frame_number === frameNumber?.ds_frame_number
                ? "green"
                : "red",
            fontWeight: "bold",
          }}
        >
          Status Frame Number : {frameNumber?.ds_frame_number}
        </p>
      </div>

      {/* 기능 */}
      <div style={{ marginBottom: 8, fontWeight: "bold" }}>
        {t("doorlock_detail_modal.function")}
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "14px 12px",
          marginBottom: 8,
        }}
      >
        {/* 도어 오픈 버튼 */}
        <button
          style={funcBtnStyle}
          onClick={() =>
            handleForcedOpening(
              roomItem?.dl_serial,
              roomItem?.frame_number,
              roomItem?.building_index,
              roomItem?.floor_index,
              roomItem?.room_index
            )
          }
        >
          {t("doorlock_detail_modal.door_open")}
        </button>
        {/* 도어락 시간 설정 버튼 */}
        <button
          style={funcBtnStyle}
          onClick={() =>
            handleSetDoorLockTime(
              roomItem?.dl_serial,
              roomItem?.frame_number,
              roomItem?.building_index,
              roomItem?.floor_index,
              roomItem?.room_index
            )
          }
        >
          {t("doorlock_detail_modal.set_door_lock_time")}
        </button>
        {/* 락아웃 (카드키) */}
        <button
          style={funcBtnStyle}
          onClick={() =>
            handleChangeDoorLockSequenceNumber(
              roomItem?.dl_serial,
              roomItem?.frame_number,
              roomItem?.building_index,
              roomItem?.floor_index,
              roomItem?.room_index,
              roomItem?.card_guest_seq_num,
              roomItem?.room_id
            )
          }
        >
          {t("doorlock_detail_modal.change_door_lock_sequence_number")}
        </button>
        {/* 객실 이동 (카드키) 버튼 / A객실 에서 B객실로 변경시
(A객실 카드를 B객실에서 사용가능하도록 도어락에서 허용처리) */}
        <button style={funcBtnStyle} onClick={handleMoveRoomCardKeyModalOpen}>
          {t("doorlock_detail_modal.move_room_card_key")}
        </button>
        {/* 체크아웃 시간 연장 버튼 */}
        <button style={funcBtnStyle} onClick={handleCheckOutChangeModalOpen}>
          {t("doorlock_detail_modal.extension_of_check_out_time")}
        </button>
        {/* 객실 상태 변경 버튼 */}
        <button style={funcBtnStyle} onClick={handleChangeRoomStatusModalOpen}>
          {t("doorlock_detail_modal.change_room_status")}
        </button>
        {/* 객실 이동 (핀코드) 버튼 / A객실 에서 B객실로 변경시 */}
        <button style={funcBtnStyle} onClick={handleMoveRoomPinCodeModalOpen}>
          {t("doorlock_detail_modal.move_room_pin_code")}
        </button>
        {/* 상태 로그 */}
        <button
          style={funcBtnStyle}
          onClick={() =>
            handleLogsModalOpen(t("doorlock_detail_modal.status_logd"))
          }
        >
          {t("doorlock_detail_modal.status_logd")}
        </button>
        {/* 제어 로그 */}
        <button
          style={funcBtnStyle}
          onClick={() =>
            handleLogsModalOpen(t("doorlock_detail_modal.control_logd"))
          }
        >
          {t("doorlock_detail_modal.control_logd")}
        </button>
        {/* 락아웃 (핀코드) */}
        <button
          style={funcBtnStyle}
          onClick={() =>
            handleChangeLockOutPinCode(
              roomItem?.dl_serial,
              roomItem?.frame_number,
              roomItem?.building_index,
              roomItem?.floor_index,
              roomItem?.room_index,
              roomItem?.pincode_v3_guest_seq_num,
              roomItem?.room_id
            )
          }
        >
          {t("doorlock_detail_modal.lock_out_pin_code")}
        </button>
      </div>
      {/* 전체 동기화 버튼 */}
      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button
          style={{
            background: "#0288d1",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            padding: "10px 36px",
            fontWeight: "bold",
            fontSize: 16,
            cursor: "pointer",
          }}
          onClick={handleFrameCount}
        >
          {t("doorlock_detail_modal.full_sync")}
        </button>
      </div>
      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button
          style={{
            background: "#0288d1",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            padding: "10px 36px",
            fontWeight: "bold",
            fontSize: 16,
            cursor: "pointer",
          }}
          onClick={handleMqttModalOpen}
        >
          {"Mqtt 통신 테스트"}
        </button>
      </div>
    </div>
  );
};

export default DoorlockTileDetail;
